// extracted by mini-css-extract-plugin
module.exports = {"pieChartContainer":"styles_pieChartContainer__3JwHU","pieChart":"styles_pieChart__i7uDc","chartTitle":"styles_chartTitle__2rCuQ","tooltip":"styles_tooltip__2Nwij"};